import { ReactNode, createContext, useContext } from "react";
import { useLoading } from "../hooks/use-loading";
import LoadingOverlay from "../components/LoadingOverlay";

interface LoadingAction {
  setIsLoading: (v: boolean) => void;
  isLoading: boolean;
}

/**
 * loading context provider setter fn
 */
const loadingContext = createContext<LoadingAction | undefined>(undefined);

/**
 * this hook design to return notNullable value
 * @returns loadingContext
 */
export const useLoadingContext = () => {
  const context = useContext(loadingContext);

  /** throw error in case of loading context not wrap within loadingProvider */
  if (!context)
    throw new Error("loading context must be wrap within loadingProvider");

  return context;
};

/**
 * LoadingProvider component to manage loading state and provide context
 * @param children - ReactNode elements to be wrapped by the provider
 *
 * @author rajkumar rathod
 */
export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useLoading();
  return (
    <loadingContext.Provider value={{ setIsLoading, isLoading }}>
      {children}
      <LoadingOverlay isLoading={isLoading} />
    </loadingContext.Provider>
  );
};
